module.exports = __webpack_public_path__ + "static/media/icon_basic_info.8746aca6.svg";